import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonModal,
  IonPage,
  IonRow,
} from "@ionic/react";
import { useHistory, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import TopLeftUserName from "../components/TopLeftUserName";
import AssessmentDescription from "../components/modals/assessment-description";
import { TestType } from "../models/Enums";
import { useRecoilState } from "recoil";
import {
  currentAssessmentState,
  networkConnectionStatus,
  PatientState,
} from "../data/atoms";
import { Assessment } from "../models/AssessmentRelated/Assessment";
import gaitAssesment from "../assets/images/gaitImage_1.png";
import fivesitStand from "../assets/images/5XsitStand_1.png";
import upperBodyAromAssessment from "../assets/images/vstUpperBodyAROM.png";
import mCTSIB from "../assets/images/mCTSIB.png";
import functionalReachAssessment from "../assets/images/Functional_Reach_updated.png";
import redLightGreenLight from "../assets/images/redLightGreenLight.png";
import appleFrenzy from "../assets/images/Apple-Frenzy.png";
import ballonPopper from "../assets/images/Balloon-Popper.png";
import veggieSlicer from "../assets/images/veggie-slicer.png";
import tugAssessment from "../assets/images/tug.png";
import { loadUnityScene } from "../utils/mobile-bridge";
import { secureRandom } from "../utils/secureRandom";

import {
  StartAssessment,
  StartTest,
  CompleteTest,
  CompleteTestPhase,
} from "../services/AssessmentsService";
import { calculateOverallScores } from "../vision-algo/mCTSIB_score_calculations";
import { v4 as uuidv4 } from "uuid";
import {
  convertDOBintoAge,
  formatAMPM,
  getCurrentDay,
  getLocalStringDate,
} from "../utils/sharedFunction";
import Loader from "../components/LoaderComponent";
import { ASSESSMENT_STATUSES } from "../movenet/params";

const SelectAnAssessment: React.FC = () => {
  let history = useHistory();
  const location = useLocation();
  const [assessmentDescModal, setShowModal1] = useState(false);
  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState,
  );
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [activeTab, setActiveTab] = useState<"assessment" | "training">(
    "assessment",
  );
  const [patientInfo, setPatientInfo] = useRecoilState(PatientState);
  const [isLoading, setIsLoading] = useState(false);

  const handleTabClick = (tab: "assessment" | "training") => {
    setActiveTab(tab);
  };
  const movementTypes = ["HANDS", "LATERAL_STEP", "LEAN"];
  let dummyAppleFrenzyData = {};

  useEffect(() => {
    setActiveTab("assessment");
    setIsLoading(false);
  }, [location]);

  function getRandomMovementType() {
    const index = Math.floor(secureRandom() * movementTypes.length);
    return movementTypes[index];
  }

  // Define dummy data for RLGL
  var dummyRLGLData = {
    plugin: "Kinect2",
    activity_id: "PhaseComplete",
    test_type: "game_RLGL",
    meters_displayed: "4",
    time_spent: "60",
    average_speed: "0.1",
    red_lights_failed: "8",
    meters_lost: "40",
    difficulty: {
      movementDifficulty: "EASY",
      gameTime: "1:00",
      redLightFrequency: "HIGH_FREQUENCY",
    },
  };

  function generateAppleFrenzyData(movementType: string) {
    const baseData = {
      plugin: "Kinect2",
      activity_id: "PhaseComplete",
      test_type: "game_AF",
      user1PlayedSeated: secureRandom() > 0.5 ? "True" : "False",
      goodApples: "10",
      badApples: "2",
      goodApplePercentageCaught: "0.83",
      badApplePercentageCaught: "0.50",
      applesMissed: "2",
      bestStreak: "6",
      score: "2100",
      infiniteModeTimeLasted: "21.53602",
      maxLeanAngleLeft: "-",
      maxLeanAngleRight: "-",
      difficulty: {
        movementType,
        movementDifficulty: "MEDIUM",
        gameTime: "60",
      },
    };

    // Conditionally fill in values
    if (movementType === "HANDS") {
      return {
        ...baseData,
        maxArmReachLeft: (0.7 + secureRandom() * 0.2).toFixed(3),
        maxArmReachRight: (0.7 + secureRandom() * 0.2).toFixed(3),
        averageArmOffsetPolled:
          Array(6)
            .fill(0)
            .map(() => (-(0.15 + secureRandom() * 0.05)).toFixed(3))
            .join(",") + ",",
        bothArmDuration: (10 + secureRandom() * 5).toFixed(3),
        leftArmOnlyDuration: (5 + secureRandom() * 3).toFixed(3),
        rightArmOnlyDuration: (8 + secureRandom() * 4).toFixed(3),
        totalLateralMovement: "-",
        maxLateralStepLength: "-",
        maxLateralStepLengthRight: "-",
        maxLateralStepLengthLeft: "-",

        maxLeanAngleLeft: "-",
        maxLeanAngleRight: "-",
      };
    }

    if (movementType === "LATERAL_STEP") {
      return {
        ...baseData,
        totalLateralMovement: (0.05 + secureRandom() * 0.05).toFixed(3),
        maxLateralStepLength: (0.15 + secureRandom() * 0.05).toFixed(3),
        maxLateralStepLengthRight: (secureRandom() * 0.2).toFixed(3),
        maxLateralStepLengthLeft: (secureRandom() * 0.2).toFixed(3),
        maxArmReachLeft: "-",
        maxArmReachRight: "-",
        averageArmOffsetPolled: "-",
        bothArmDuration: "-",
        leftArmOnlyDuration: "-",
        rightArmOnlyDuration: "-",

        maxLeanAngleLeft: "-",
        maxLeanAngleRight: "-",
      };
    }
    if (movementType === "LEAN") {
      return {
        ...baseData,
        totalLateralMovement: "-",
        maxLateralStepLength: "-",
        maxLateralStepLengthRight: "-",
        maxLateralStepLengthLeft: "-",
        maxArmReachLeft: "-",
        maxArmReachRight: "-",
        averageArmOffsetPolled: "-",
        bothArmDuration: "-",
        leftArmOnlyDuration: "-",
        rightArmOnlyDuration: "-",

        maxLeanAngleLeft: (secureRandom() * 0.2).toFixed(3),
        maxLeanAngleRight: (secureRandom() * 0.2).toFixed(3),
      };
    }

    return baseData;
  }

  let dummyBallonPopperData = {
    plugin: "Kinect2",
    activity_id: "PhaseComplete",
    test_type: "hec_training",
    user1PlayedSeated: "False", // Will be "True" if the user played seated, otherwise "False"
    xml_version: "1",
    score: "33589",
    scorePerMinute: "33589",
    averageTimeToHit: "1.8",
    averageTimeToHitTrend:
      "0,1.86,3.43,3.95,4.21,3.54,2.65,2.28,2.05,1.93,1.87,1.83,1.81,",
    totalBalloonsHit: "29",
    balloonsHitPerMinute: "29",
    totalBalloonsMissed: "4",
    balloonsMissedPerMinute: "4",
    settings: {
      time: "60",
      reachDifficulty: "MEDIUM",
      reachDirection: "BOTH",
      armMode: "BOTH",
    },
    leftHand: {
      leftAcrossHit: "5",
      leftAcrossMissed: "2",
      leftAcrossAvgTimeToHit: "2.338095",
      leftAcrossReachDist: "0.3646774",
      leftOutwardHit: "8",
      leftOutwardMissed: "1",
      leftOutwardAvgTimeToHit: "1.877777",
      leftOutwardReachDist: "0.844736",
    },
    rightHand: {
      rightAcrossHit: "8",
      rightAcrossMissed: "0",
      rightAcrossAvgTimeToHit: "1.377083",
      rightAcrossReachDist: "0.3378764",
      rightOutwardHit: "8",
      rightOutwardMissed: "1",
      rightOutwardAvgTimeToHit: "1.701851",
      rightOutwardReachDist: "0.8166302",
    },
  };

  function generateBalloonPopperData() {
    // Helper function to generate trend data
    const generateTrend = () => {
      let trend = ["0"];
      let value = 1.5;
      for (let i = 0; i < 12; i++) {
        value += (secureRandom() - 0.5) * 1.5;
        value = Math.max(0.5, Math.min(5, value)); // Keep between 0.5 and 5
        trend.push(value.toFixed(2));
      }
      return trend.join(",") + ",";
    };

    // Generate random integers within a range
    const randomInt = (min: number, max: number) =>
      Math.floor(min + secureRandom() * (max - min + 1));

    // Generate random float with fixed precision
    const randomFloat = (min: number, max: number, precision: number = 6) =>
      (min + secureRandom() * (max - min)).toFixed(precision);

    const totalHit = randomInt(25, 35);
    const totalMissed = randomInt(2, 6);

    return {
      plugin: "Kinect2",
      activity_id: "PhaseComplete",
      test_type: "hec_training",
      user1PlayedSeated: secureRandom() > 0.7 ? "True" : "False",
      xml_version: "1",
      score: (totalHit * 1000 + randomInt(500, 1500)).toString(),
      scorePerMinute: (totalHit * 1000 + randomInt(500, 1500)).toString(),
      averageTimeToHit: randomFloat(1.5, 2.5, 1),
      averageTimeToHitTrend: generateTrend(),
      totalBalloonsHit: totalHit.toString(),
      balloonsHitPerMinute: totalHit.toString(),
      totalBalloonsMissed: totalMissed.toString(),
      balloonsMissedPerMinute: totalMissed.toString(),
      settings: {
        time: "60",
        reachDifficulty: "MEDIUM",
        reachDirection: "BOTH",
        armMode: "BOTH",
      },
      leftHand: {
        leftAcrossHit: randomInt(4, 8).toString(),
        leftAcrossMissed: randomInt(0, 2).toString(),
        leftAcrossAvgTimeToHit: randomFloat(1.8, 2.5),
        leftAcrossReachDist: randomFloat(0.3, 0.4),
        leftOutwardHit: randomInt(6, 10).toString(),
        leftOutwardMissed: randomInt(0, 2).toString(),
        leftOutwardAvgTimeToHit: randomFloat(1.7, 2.2),
        leftOutwardReachDist: randomFloat(0.7, 0.9),
      },
      rightHand: {
        rightAcrossHit: randomInt(6, 10).toString(),
        rightAcrossMissed: randomInt(0, 2).toString(),
        rightAcrossAvgTimeToHit: randomFloat(1.3, 1.8),
        rightAcrossReachDist: randomFloat(0.3, 0.4),
        rightOutwardHit: randomInt(6, 10).toString(),
        rightOutwardMissed: randomInt(0, 2).toString(),
        rightOutwardAvgTimeToHit: randomFloat(1.5, 2.0),
        rightOutwardReachDist: randomFloat(0.7, 0.9),
      },
    };
  }

  function generateVeggieSamuraiData() {
    // Helper functions
    const randomInt = (min: number, max: number) =>
      Math.floor(min + secureRandom() * (max - min + 1));

    const randomFloat = (min: number, max: number, precision: number = 2) =>
      (min + secureRandom() * (max - min)).toFixed(precision);

    // Totals
    const totalVeggies = randomInt(12, 20);
    const veggiesMissed = randomInt(2, 6);
    const veggiesCut = totalVeggies - veggiesMissed;

    const veggiesAccuracy = (veggiesCut / totalVeggies).toFixed(2);

    const totalSponges = randomInt(12, 20);
    const spongesMissed = randomInt(2, 6);
    const spongesCut = totalSponges - spongesMissed;
    const spongesAccuracy = (spongesCut / totalSponges).toFixed(2);

    // Split between hands
    const rightVeggies = randomInt(veggiesCut / 2 - 2, veggiesCut / 2 + 2);
    const leftVeggies = veggiesCut - rightVeggies;

    const rightSponges = Math.floor(spongesCut / 2);
    const leftSponges = spongesCut - rightSponges;

    return {
      plugin: "Kinect2",
      activity_id: "PhaseComplete",
      test_type: "veggie_samurai",
      user1PlayedSeated: secureRandom() > 0.7 ? "True" : "False",
      score: (veggiesCut * 100 + randomInt(50, 150)).toString(),
      scorePerMinute: (veggiesCut * 50 + randomInt(20, 80)).toString(),
      veggies_cut: veggiesCut.toString(),
      veggies_missed: veggiesMissed.toString(),
      veggie_accuracy: veggiesAccuracy,
      sponges_cut: spongesCut.toString(),
      sponge_accuracy: spongesAccuracy,
      Left: {
        veggies_cut: "-",
        sponges_cut: "-",
      },
      Right: {
        veggies_cut: leftVeggies.toString(),
        sponges_cut: leftSponges.toString(),
      },
      difficulty: {
        time: randomInt(30, 120).toString(),
        vegetableMoveSpeed: ["SLOW", "MEDIUM", "FAST"][randomInt(0, 2)] as
          | "SLOW"
          | "MEDIUM"
          | "FAST",
        reachDifficulty: ["EASY", "MEDIUM", "HARD"][randomInt(0, 2)] as
          | "EASY"
          | "MEDIUM"
          | "HARD",
        armMode: ["LEFT_ONLY", "RIGHT_ONLY", "BOTH"][randomInt(0, 2)] as
          | "LEFT_ONLY"
          | "RIGHT_ONLY"
          | "BOTH",
      },
    };
  }

  let dummyVeggieSamuraiData = {
    plugin: "Kinect2",
    activity_id: "PhaseComplete",
    test_type: "veggie_samurai",
    user1PlayedSeated: "False", // "True" if user played seated
    score: "41",
    scorePerMinute: "41",
    veggies_cut: "41",
    veggies_missed: "3",
    veggie_accuracy: "0.93",
    sponges_cut: "0",
    sponge_accuracy: "0.00",
    Right: {
      veggies_cut: "41",
      sponges_cut: "0",
    },
    Left: {
      veggies_cut: "41",
      sponges_cut: "0",
    },
    difficulty: {
      time: "60",
      vegetableMoveSpeed: "SLOW",
      reachDifficulty: "EASY",
      armMode: "LEFT_ONLY",
    },
  };

  let dummyTugData = {
    test_type: "tug",
    start_time: new Date().toISOString(), // Current timestamp
    end_time: new Date(Date.now() + 15000).toISOString(), // 15 seconds later
    gait: {
      fall_risk: "2.45", // Typical range 0-5
      tug_speed: 1.2, // Typical range 0.8-1.5 m/s
      distance: 6, // Standard TUG test distance in meters
      ambulation_time: 12.5, // Typical range 8-15 seconds
      velocity: 120, // tug_speed * 100
      mean_normalized_velocity: 175.18, // Keeping the same value as example
      number_of_steps: 15, // Typical range 12-20 steps
      cadence: 72, // steps per minute (60 * steps/time)
      used_assistive_device: "False",
    },
  };
  let dummyFunctionalReachData = {
    test_type: "functional_Reach",
    start_time: new Date().toISOString(), // Current timestamp
    end_time: new Date(Date.now() + 15000).toISOString(), // 15 seconds later
    phases: [
      {
        maximum_reach: 20.8, // Left reach - typical range 10-30 cm
        maximum_reach_time: 0,
        phase_score: 20.8,
        mode: {
          index: 0,
          code: "left",
        },
      },
      {
        maximum_reach: 22.3, // Right reach - typical range 10-30 cm
        maximum_reach_time: 0,
        phase_score: 22.3,
        mode: {
          index: 1,
          code: "right",
        },
      },
      {
        maximum_reach: 28.5, // Forward reach - typical range 15-35 cm
        maximum_reach_time: 0,
        phase_score: 28.5,
        mode: {
          index: 2,
          code: "forward",
        },
      },
    ],
  };

  let dummyMctsibData = [
    {
      test_type: "ctsib",
      skeletons_csv:
        "C:\\VirtuSense\\VSClient\\bin/../Temp/skeletons-qxmvocyb.rbo.csv",
      elapsed_time: 3967,
      cumulative_sway_distance: 0.0419219265753896,
      mean_displacement_from_start: 0.0105608973917517,
      sway_range_x: 0.0189871713519096,
      sway_range_y: 0.00105366110801697,
      sway_range_z: 0.00713443756103516,
      phase_score: 12.5959243849224,
      mode: {
        index: 0,
        code: "eyes_open_standing_on_floor",
      },
      start_time: "2026-01-16 10:18:13.370",
      end_time: "2026-01-16 10:18:22.915",
    },
    {
      test_type: "ctsib",
      skeletons_csv:
        "C:\\VirtuSense\\VSClient\\bin/../Temp/skeletons-5yfpj0rg.2nq.csv",
      elapsed_time: 6534,
      cumulative_sway_distance: 0.0339788924172117,
      mean_displacement_from_start: 0.00494159620715188,
      sway_range_x: 0.00863516703248024,
      sway_range_y: 0.00602394342422485,
      sway_range_z: 0.0119717121124268,
      phase_score: 22.0528469221677,
      mode: {
        index: 1,
        code: "eyes_closed_standing_on_floor",
      },
      start_time: "2026-01-16 10:18:13.370",
      end_time: "2026-01-16 10:18:22.947",
    },
    {
      test_type: "ctsib",
      skeletons_csv:
        "C:\\VirtuSense\\VSClient\\bin/../Temp/skeletons-gcpktvb1.4ll.csv",
      elapsed_time: 6100,
      cumulative_sway_distance: 0.0245882621397576,
      mean_displacement_from_start: 0.00430341132641063,
      sway_range_x: 0.011429388076067,
      sway_range_y: 0.00140586495399475,
      sway_range_z: 0.00807571411132813,
      phase_score: 20.8981476943252,
      mode: {
        index: 2,
        code: "eyes_open_standing_on_foam",
      },
      start_time: "2026-01-16 10:18:13.370",
      end_time: "2026-01-16 10:18:22.972",
    },
    {
      test_type: "ctsib",
      skeletons_csv:
        "C:\\VirtuSense\\VSClient\\bin/../Temp/skeletons-tkm0f521.mpt.csv",
      elapsed_time: 5900,
      cumulative_sway_distance: 0.0210850188548182,
      mean_displacement_from_start: 0.00385551570077192,
      sway_range_x: 0.0106865391135216,
      sway_range_y: 0.00106485188007355,
      sway_range_z: 0.00716781616210938,
      phase_score: 20.3422265417396,
      mode: {
        index: 3,
        code: "eyes_closed_standing_on_foam",
      },
      start_time: "2026-01-16 10:18:13.370",
      end_time: "2026-01-16 10:18:22.994",
    },
  ];

  function generateRandomMctsibData() {
    const modes = [
      "eyes_open_standing_on_floor",
      "eyes_closed_standing_on_floor",
      "eyes_open_standing_on_foam",
      "eyes_closed_standing_on_foam",
    ];

    const getRandomNumber = (min: number, max: number) => {
      return +(secureRandom() * (max - min) + min).toFixed(6);
    };

    const startTimeBase = new Date();

    return modes.map((mode, index) => {
      const elapsedTime = Math.floor(getRandomNumber(3000, 10000));
      const startTime = new Date(startTimeBase.getTime() + index * 10000);
      const endTime = new Date(startTime.getTime() + elapsedTime);

      const formatDateTime = (date: Date) => {
        const pad = (n: number) => (n < 10 ? "0" + n : n);
        return (
          date.getFullYear() +
          "-" +
          pad(date.getMonth() + 1) +
          "-" +
          pad(date.getDate()) +
          " " +
          pad(date.getHours()) +
          ":" +
          pad(date.getMinutes()) +
          ":" +
          pad(date.getSeconds()) +
          "." +
          String(date.getMilliseconds()).padStart(3, "0")
        );
      };

      return {
        test_type: "ctsib",
        skeletons_csv: "",
        elapsed_time: elapsedTime,
        cumulative_sway_distance: getRandomNumber(0.01, 0.05),
        mean_displacement_from_start: getRandomNumber(0.003, 0.012),
        sway_range_x: getRandomNumber(0.005, 0.02),
        sway_range_y: getRandomNumber(0.001, 0.007),
        sway_range_z: getRandomNumber(0.005, 0.015),
        phase_score: getRandomNumber(10, 25),
        mode: {
          index: index,
          code: mode,
        },
        start_time: formatDateTime(startTime),
        end_time: formatDateTime(endTime),
      };
    });
  }

  function generateRandomTugData() {
    // Helper function to get random number between min and max
    const getRandomNumber = (min: number, max: number) => {
      return +(secureRandom() * (max - min) + min).toFixed(2);
    };

    // Generate random time duration between 8-16 seconds
    const totalTimeSeconds = getRandomNumber(8, 16);
    const gaitTime = totalTimeSeconds * 1000; // Convert to milliseconds
    const stepCount = Math.floor(getRandomNumber(12, 20));
    const gaitSpeed = getRandomNumber(0.8, 1.5);

    const startTime = new Date();
    const endTime = new Date(startTime.getTime() + gaitTime);

    return {
      test_type: "tug",
      start_time: startTime.toISOString(),
      end_time: endTime.toISOString(),
      gait: {
        fall_risk: getRandomNumber(1, 5).toFixed(2),
        tug_speed: gaitSpeed,
        distance: getRandomNumber(2.6, 0.1), // Standard TUG distance
        ambulation_time: totalTimeSeconds, // Time in seconds
        velocity: getRandomNumber(74.286, 10.0),
        mean_normalized_velocity: getRandomNumber(0.95, 0.05),
        number_of_steps: stepCount,
        cadence: getRandomNumber(85.7, 10.0),
        used_assistive_device: secureRandom() > 0.8 ? "True" : "False", // 20% chance of using device
      },
      timing: {
        total: gaitTime, // Time in milliseconds (will be divided by 1000 in display)
      },
    };
  }

  function generateRandomFunctionalReachData() {
    // Helper function to get random number between min and max
    const getRandomNumber = (min: number, max: number) => {
      return +(secureRandom() * (max - min) + min).toFixed(2);
    };

    // Generate random test duration between 30-60 seconds
    const testDuration = Math.floor(secureRandom() * (60 - 30 + 1) + 30) * 1000;

    const startTime = new Date();
    const endTime = new Date(startTime.getTime() + testDuration);

    // Generate values directly in inches
    const leftReach = getRandomNumber(8, 12); // Left lateral reach in inches
    const rightReach = getRandomNumber(8, 12); // Right lateral reach in inches
    const forwardReach = getRandomNumber(10, 15); // Forward reach in inches

    return {
      test_type: "functional_Reach",
      start_time: startTime.toISOString(),
      end_time: endTime.toISOString(),
      phases: [
        {
          maximum_reach: leftReach, // Left reach in inches
          maximum_reach_time: 0,
          phase_score: leftReach,
          mode: {
            index: 0,
            code: "left",
          },
        },
        {
          maximum_reach: rightReach, // Right reach in inches
          maximum_reach_time: 0,
          phase_score: rightReach,
          mode: {
            index: 1,
            code: "right",
          },
        },
        {
          maximum_reach: forwardReach, // Forward reach in inches
          maximum_reach_time: 0,
          phase_score: forwardReach,
          mode: {
            index: 2,
            code: "forward",
          },
        },
      ],
    };
  }

  const simulateUnityTraining = async (value: any) => {
    setIsLoading(true);
    debugger;
    let testLookupId: any;

    if (value === TestType.game_AF) {
      testLookupId = TestType.game_AF;
    } else if (value === TestType.red_light_green_light) {
      testLookupId = TestType.red_light_green_light;
    } else if (value === TestType.hec_training) {
      testLookupId = TestType.hec_training;
    } else if (value === TestType.veggie_samurai) {
      testLookupId = TestType.veggie_samurai;
    } else if (value === TestType.tug) {
      testLookupId = TestType.tug;
    } else if (value === TestType.reach) {
      testLookupId = TestType.reach;
    } else if (value === TestType.ctsib) {
      testLookupId = TestType.ctsib;
    }

    const localtime = new Date(
      new Date().setHours(
        new Date().getHours() - new Date().getTimezoneOffset() / 60,
      ),
    ).toISOString();

    // Start the assessment
    const startAssessmentResponse = await StartAssessment({
      PatientId: localStorage.getItem("patientServerID"),
      AdmissionDateUTC: new Date(),
      LocalDateTime: localtime,
    });
    if (startAssessmentResponse) {
      const masterTestId = startAssessmentResponse.data.masterTestId;

      // Start the test
      setcurrentAssessmentState((prevState: Assessment) => ({
        ...prevState,
        masterTestId: masterTestId,
        patientId: Number(localStorage.getItem("patientServerID")),
      }));

      console.log("currentAssessment", currentAssessment);

      const startTestResponse = await StartTest({
        LocalDateTime: localtime,
        PatientId: localStorage.getItem("patientServerID"),
        TestLookupId: testLookupId,
        MasterTestId: masterTestId,
        IsSubTest: false,
      });

      if (startTestResponse) {
        setcurrentAssessmentState((prevState: Assessment) => ({
          ...prevState,
          visitId: startTestResponse.data.visitId,
          testId: startTestResponse.data.testId,
          assessmentType: testLookupId,
        }));

        console.log("currentAssessment", currentAssessment);

        const testId = startTestResponse.data.testId;
        const visitId = startTestResponse.data.visitId;

        let dataToUse = {};
        if (value === 50) {
          dataToUse = dummyAppleFrenzyData;
        } else if (value === 51) {
          dataToUse = dummyRLGLData;
        } else if (value === 21) {
          dataToUse = dummyBallonPopperData;
        } else if (value === 41) {
          dataToUse = dummyVeggieSamuraiData;
        } else if (value === 31) {
          dataToUse = dummyTugData;
        } else if (value === TestType.reach) {
          dataToUse = dummyFunctionalReachData;
        } else if (value === TestType.ctsib) {
          dataToUse = dummyMctsibData;
        }

        // Handle Functional Reach or mCTSIB with multiple phases
        if (
          (value === TestType.reach && dummyFunctionalReachData.phases) ||
          (value === TestType.ctsib && Array.isArray(dummyMctsibData))
        ) {
          const phases =
            value === TestType.reach
              ? dummyFunctionalReachData.phases
              : dummyMctsibData;

          let lastPhaseId = 0;

          // Loop through each phase and complete it
          for (const phaseData of phases) {
            const jsonstrwithroot = {
              root: {
                ...phaseData,
                test_type:
                  value === TestType.reach ? "functional_Reach" : "ctsib",
              },
            };

            console.log(`Preparing CompleteTestPhase for assessment:`, {
              TestId: testId,
              TestJson: JSON.stringify(jsonstrwithroot),
            });

            const result = await CompleteTestPhase({
              TestId: testId,
              VisitInfo: "",
              AdmissionDateUTC: localtime,
              LocalDateTime: localtime,
              UTCDateTime: localtime,
              StartTime: localtime,
              StartTimeUTC: localtime,
              EndTime: localtime,
              EndTimeUTC: localtime,
              TestJson: JSON.stringify(jsonstrwithroot),
            });

            if (result && result.data) {
              lastPhaseId = result.data.id;
              setcurrentAssessmentState((prevState: Assessment) => ({
                ...prevState,
                phaseId: result.data.id,
              }));
            }
          }

          let scoreTags = "";
          if (testLookupId === TestType.ctsib) {
            const dataToPass =
              JSON.parse(currentAssessment.testJson)?.root || [];
            const overallScores: any = calculateOverallScores(dataToPass);
            scoreTags = JSON.stringify(overallScores.scores);
          }

          CompleteTest({
            TestId: testId,
            VisitId: visitId,
            AssessmentType: testLookupId,
            PatientId: localStorage.getItem("patientServerID"),
            TestLookupId: testLookupId,
            MasterTestId: masterTestId,
            PhaseId: lastPhaseId,
            ScoreTags: scoreTags,
          })
            .then(async (res: any) => {
              if (res.data.responseCode == 1) {
                let summaryDetail = {
                  date: getCurrentDay(),
                  dateFormat: getLocalStringDate(),
                  time: formatAMPM(new Date()),
                };
                let assessmentSummaryArray = JSON.parse(
                  localStorage.getItem("summaryDetail") ?? "[]",
                );
                let getJSONSummary = JSON.parse(
                  localStorage.getItem("Assessment Summary")!,
                );
                let assessmentID = uuidv4();
                let patientServerID = localStorage.getItem("patientServerID")
                  ? localStorage.getItem("patientServerID")
                  : "000";
                let patientName = localStorage.getItem("patientName")
                  ? localStorage.getItem("patientName")!
                  : "Name Required";

                getJSONSummary = {
                  assessmentID: assessmentID,
                  patientServerID: patientServerID,
                  patientName: patientName,
                  patientAge: convertDOBintoAge(new Date(patientInfo?.dob)),
                  ...summaryDetail,
                  ...getJSONSummary,
                };
                assessmentSummaryArray.push(getJSONSummary);
                localStorage.setItem(
                  "summaryDetail",
                  JSON.stringify(assessmentSummaryArray),
                );
                localStorage.setItem(
                  "selectedAssesment",
                  JSON.stringify(assessmentID),
                );
                setIsLoading(false);
                setTimeout(() => {
                  history.replace("/patient-assessment-summary", {
                    pageHeaderText: "Full Visit Summary",
                    isAssessmentCompleted: true,
                  });
                }, 200);
              }
            })
            .catch((err) => {
              setIsLoading(false);
              console.error(err);
            });
        } else {
          // Handle non-Functional Reach assessments (existing logic)
          const jsonstr = JSON.stringify(dataToUse);
          const jsonstrwithroot = { root: JSON.parse(jsonstr) };

          console.log("Preparing CompleteTestPhase with data:", {
            TestId: testId,
            VisitInfo: "",
            AdmissionDateUTC: localtime,
            LocalDateTime: localtime,
            UTCDateTime: localtime,
            StartTime: localtime,
            StartTimeUTC: localtime,
            EndTime: localtime,
            EndTimeUTC: localtime,
            TestJson: JSON.stringify(jsonstrwithroot),
          });

          await CompleteTestPhase({
            TestId: testId,
            VisitInfo: "",
            AdmissionDateUTC: localtime,
            LocalDateTime: localtime,
            UTCDateTime: localtime,
            StartTime: localtime,
            StartTimeUTC: localtime,
            EndTime: localtime,
            EndTimeUTC: localtime,
            TestJson: JSON.stringify(jsonstrwithroot),
          })
            .then((result: any) => {
              setcurrentAssessmentState((prevState: Assessment) => ({
                ...prevState,
                phaseId: result.data.id,
              }));

              console.log("currentAssessment", currentAssessment);

              CompleteTest({
                TestId: testId,
                VisitId: visitId,
                TestJson: JSON.stringify(jsonstrwithroot),
                AssessmentType: testLookupId,
                PatientId: localStorage.getItem("patientServerID"),
                TestLookupId: testLookupId,
                MasterTestId: masterTestId,
                PhaseId: result.data.id,
              })
                .then(async (res: any) => {
                  if (res.data.responseCode == 1) {
                    let summaryDetail = {
                      date: getCurrentDay(),
                      dateFormat: getLocalStringDate(),
                      time: formatAMPM(new Date()),
                    };
                    let assessmentSummaryArray = JSON.parse(
                      localStorage.getItem("summaryDetail") ?? "[]",
                    );
                    let getJSONSummary = JSON.parse(
                      localStorage.getItem("Assessment Summary")!,
                    );
                    let assessmentID = uuidv4();
                    let patientServerID = localStorage.getItem(
                      "patientServerID",
                    )
                      ? localStorage.getItem("patientServerID")
                      : "000";
                    let patientName = localStorage.getItem("patientName")
                      ? localStorage.getItem("patientName")!
                      : "Name Required";

                    getJSONSummary = {
                      assessmentID: assessmentID,
                      patientServerID: patientServerID,
                      patientName: patientName,
                      patientAge: convertDOBintoAge(new Date(patientInfo?.dob)),
                      ...summaryDetail,
                      ...getJSONSummary,
                    };
                    assessmentSummaryArray.push(getJSONSummary);
                    localStorage.setItem(
                      "summaryDetail",
                      JSON.stringify(assessmentSummaryArray),
                    );
                    localStorage.setItem(
                      "selectedAssesment",
                      JSON.stringify(assessmentID),
                    );
                    setIsLoading(false);
                    setTimeout(() => {
                      debugger;
                      history.replace("/patient-assessment-summary", {
                        pageHeaderText: "Full Visit Summary",
                        isAssessmentCompleted: true,
                      });
                    }, 200);
                  }
                })
                .catch((err) => {
                  setIsLoading(false);
                  console.error(err);
                });
            })
            .catch((err) => {
              setIsLoading(false);
              console.error(err);
            });
        }
      }
    } else {
      setIsLoading(false);
    }
  };

  // Function to simulate RLGL
  const simulateRLGLAssessment = async () => {
    setIsLoading(true);
    console.log("Simulating RLGL Assessment with dummy data:", dummyRLGLData);

    const localtime = new Date(
      new Date().setHours(
        new Date().getHours() - new Date().getTimezoneOffset() / 60,
      ),
    ).toISOString();

    // Start the assessment
    const startAssessmentResponse = await StartAssessment({
      PatientId: localStorage.getItem("patientServerID"),
      AdmissionDateUTC: new Date(),
      LocalDateTime: localtime,
    });

    if (startAssessmentResponse) {
      const masterTestId = startAssessmentResponse.data.masterTestId;

      // Start the test
      setcurrentAssessmentState((prevState: Assessment) => ({
        ...prevState,
        masterTestId: masterTestId,
        patientId: Number(localStorage.getItem("patientServerID")),
      }));
      const startTestResponse = await StartTest({
        LocalDateTime: localtime,
        PatientId: localStorage.getItem("patientServerID"),
        TestLookupId: TestType.red_light_green_light,
        MasterTestId: masterTestId,
        IsSubTest: false,
      });

      if (startTestResponse) {
        setcurrentAssessmentState((prevState: Assessment) => ({
          ...prevState,
          visitId: startTestResponse.data.visitId,
          testId: startTestResponse.data.testId,
        }));

        const testId = startTestResponse.data.testId;
        const visitId = startTestResponse.data.visitId;

        const jsonstr = JSON.stringify(dummyRLGLData);

        const jsonstrwithroot = { root: JSON.parse(jsonstr) };

        console.log("Preparing CompleteTestPhase with data:", {
          TestId: testId,
          VisitInfo: "",
          AdmissionDateUTC: localtime,
          LocalDateTime: localtime,
          UTCDateTime: localtime,
          StartTime: localtime,
          StartTimeUTC: localtime,
          EndTime: localtime,
          EndTimeUTC: localtime,
          TestJson: JSON.stringify(jsonstrwithroot),
        });
        await CompleteTestPhase({
          TestId: testId,
          VisitInfo: "",
          AdmissionDateUTC: localtime,
          LocalDateTime: localtime,
          UTCDateTime: localtime,
          StartTime: localtime,
          StartTimeUTC: localtime,
          EndTime: localtime,
          EndTimeUTC: localtime,
          TestJson: JSON.stringify(jsonstrwithroot),
        })
          .then((result: any) => {
            setcurrentAssessmentState((prevState: Assessment) => ({
              ...prevState,
              phaseId: result.data.id,
            }));

            CompleteTest({
              TestId: testId,
              VisitId: visitId,
              TestJson: JSON.stringify(jsonstrwithroot),
              AssessmentType: TestType.red_light_green_light,
              PatientId: localStorage.getItem("patientServerID"),
              TestLookupId: TestType.red_light_green_light,
              MasterTestId: masterTestId,
              PhaseId: result.data.id,
            })
              .then(async (res: any) => {
                if (res.data.responseCode == 1) {
                  let summaryDetail = {
                    date: getCurrentDay(),
                    dateFormat: getLocalStringDate(),
                    time: formatAMPM(new Date()),
                  };
                  let assessmentSummaryArray = JSON.parse(
                    localStorage.getItem("summaryDetail") || "[]",
                  );
                  let getJSONSummary = JSON.parse(
                    localStorage.getItem("Assesment Summary")!,
                  );
                  let assessmentID = uuidv4();
                  let patientServerID = localStorage.getItem("patientServerID")
                    ? localStorage.getItem("patientServerID")
                    : "000";
                  let patientName = localStorage.getItem("patientName")
                    ? localStorage.getItem("patientName")!
                    : "Name Required";
                  getJSONSummary = {
                    assessmentID: assessmentID,
                    patientServerID: patientServerID,
                    patientName: patientName,
                    patientAge: convertDOBintoAge(new Date(patientInfo?.dob)),
                    ...summaryDetail,
                    ...getJSONSummary,
                  };
                  assessmentSummaryArray.push(getJSONSummary);
                  localStorage.setItem(
                    "summaryDetail",
                    JSON.stringify(assessmentSummaryArray),
                  );
                  localStorage.setItem(
                    "selectedAssesment",
                    JSON.stringify(assessmentID),
                  );
                  // setIsLoading(false);
                  setTimeout(() => {
                    history.replace("/patient-assessment-summary", {
                      pageHeaderText: "Full Visit Summary",
                      isAssessmentCompleted: true,
                    });
                  }, 200);
                }
              })
              .catch((err) => {
                setIsLoading(false);
                console.error(err);
              });
          })
          .catch((err) => {
            setIsLoading(false);
            console.error(err);
          });
      }
    }
  };

  // // Function to simulate Apple Frenzy
  // const simulateAppleFrenzyAssessment = async () => {
  //   setIsLoading(true);
  //   console.log("Simulating Apple Frenzy with data:", dummyAppleFrenzyData);

  //   const localtime = new Date(
  //     new Date().setHours(
  //       new Date().getHours() - new Date().getTimezoneOffset() / 60
  //     )
  //   ).toISOString();

  //   // Start the assessment
  //   const startAssessmentResponse = await StartAssessment({
  //     PatientId: localStorage.getItem("patientServerID"),
  //     AdmissionDateUTC: new Date(),
  //     LocalDateTime: localtime,
  //   });

  //   if (startAssessmentResponse) {
  //     const masterTestId = startAssessmentResponse.data.masterTestId;

  //     // Start the test
  //     setcurrentAssessmentState((prevState: Assessment) => ({
  //       ...prevState,
  //       masterTestId: masterTestId,
  //       patientId: Number(localStorage.getItem("patientServerID")),
  //     }));

  //     const startTestResponse = await StartTest({
  //       LocalDateTime: localtime,
  //       PatientId: localStorage.getItem("patientServerID"),
  //       TestLookupId: TestType.game_AF,
  //       MasterTestId: masterTestId,
  //       IsSubTest: false,
  //     });

  //     if (startTestResponse) {
  //       setcurrentAssessmentState((prevState: Assessment) => ({
  //         ...prevState,
  //         visitId: startTestResponse.data.visitId,
  //         testId: startTestResponse.data.testId,
  //       }));

  //       const testId = startTestResponse.data.testId;
  //       const visitId = startTestResponse.data.visitId;

  //       const jsonstr = JSON.stringify(dummyAppleFrenzyData);

  //       const jsonstrwithroot = { root: JSON.parse(jsonstr) };

  //       console.log("Preparing CompleteTestPhase with data:", {
  //         TestId: testId,
  //         VisitInfo: "",
  //         AdmissionDateUTC: localtime,
  //         LocalDateTime: localtime,
  //         UTCDateTime: localtime,
  //         StartTime: localtime,
  //         StartTimeUTC: localtime,
  //         EndTime: localtime,
  //         EndTimeUTC: localtime,
  //         TestJson: JSON.stringify(jsonstrwithroot),
  //       });

  //       await CompleteTestPhase({
  //         TestId: testId,
  //         VisitInfo: "",
  //         AdmissionDateUTC: localtime,
  //         LocalDateTime: localtime,
  //         UTCDateTime: localtime,
  //         StartTime: localtime,
  //         StartTimeUTC: localtime,
  //         EndTime: localtime,
  //         EndTimeUTC: localtime,
  //         TestJson: JSON.stringify(jsonstrwithroot),
  //       })
  //         .then((result: any) => {
  //           setcurrentAssessmentState((prevState: Assessment) => ({
  //             ...prevState,
  //             phaseId: result.data.id,
  //           }));

  //           CompleteTest({
  //             TestId: testId,
  //             VisitId: visitId,
  //             TestJson: JSON.stringify(jsonstrwithroot),
  //             AssessmentType: TestType.game_AF,
  //             PatientId: localStorage.getItem("patientServerID"),
  //             TestLookupId: TestType.game_AF,
  //             MasterTestId: masterTestId,
  //             PhaseId: result.data.id,
  //           })
  //             .then(async (res: any) => {
  //               if (res.data.responseCode == 1) {
  //                 let summaryDetail = {
  //                   date: getCurrentDay(),
  //                   dateFormat: getLocalStringDate(),
  //                   time: formatAMPM(new Date()),
  //                 };
  //                 let assessmentSummaryArray = JSON.parse(
  //                   localStorage.getItem("summaryDetail") ?? "[]"
  //                 );
  //                 let getJSONSummary = JSON.parse(
  //                   localStorage.getItem("Assessment Summary")!
  //                 );
  //                 let assessmentID = uuidv4();
  //                 let patientServerID = localStorage.getItem("patientServerID")
  //                   ? localStorage.getItem("patientServerID")
  //                   : "000";
  //                 let patientName = localStorage.getItem("patientName")
  //                   ? localStorage.getItem("patientName")!
  //                   : "Name Required";

  //                 getJSONSummary = {
  //                   assessmentID: assessmentID,
  //                   patientServerID: patientServerID,
  //                   patientName: patientName,
  //                   patientAge: convertDOBintoAge(new Date(patientInfo?.dob)),
  //                   ...summaryDetail,
  //                   ...getJSONSummary,
  //                 };
  //                 assessmentSummaryArray.push(getJSONSummary);
  //                 localStorage.setItem(
  //                   "summaryDetail",
  //                   JSON.stringify(assessmentSummaryArray)
  //                 );
  //                 localStorage.setItem(
  //                   "selectedAssesment",
  //                   JSON.stringify(assessmentID)
  //                 );
  //                 setTimeout(() => {
  //                   history.replace("/patient-assessment-summary", {
  //                     pageHeaderText: "Full Visit Summary",
  //                   });
  //                 }, 200);
  //               }
  //             })
  //             .catch((err) => {
  //               setIsLoading(false);
  //               console.error(err);
  //             });
  //         })
  //         .catch((err) => {
  //           setIsLoading(false);
  //           console.error(err);
  //         });
  //     }
  //   }
  // };

  const handleClick = (value: any) => {
    ASSESSMENT_STATUSES.exit_assessment_modal = false;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    const selectedAssessment = sessionStorage.getItem("selectedAssesment");

    if (selectedAssessment !== JSON.stringify(value))
      sessionStorage.setItem("retry-counter", "0");

    sessionStorage.setItem("selectedAssesment", JSON.stringify(value));
    setcurrentAssessmentState((prevState: Assessment) => ({
      ...prevState,
      assessmentType: value,
    }));
    history.push("/select-assessment-type");
  };

  const handleTrainingClick = (value: any) => {
    //sessionStorage.setItem("selectedAssesment", JSON.stringify(value));
    // Set the current assessment state with dummy data for RLGL

    //setcurrentAssessmentState((prevState) => ({
    //...prevState,
    //  assessmentType: TestType.red_light_green_light,
    //}));
    console.log("selected training: ", value);
    if (value === TestType.red_light_green_light) {
      loadUnityScene("game_RLGL"); // For now we only have RLGL and this was my testing way of loading the unity training
    } else if (value === TestType.game_AF) {
      // const movementType = getRandomMovementType();
      // const newData = generateAppleFrenzyData(movementType);
      // console.log("🍎 Apple Frenzy Training Data:", newData);
      // dummyAppleFrenzyData = newData;
      // simulateUnityTraining(value);
      loadUnityScene("game_AF");
    } else if (value === TestType.hec_training) {
      const newData = generateBalloonPopperData();
      dummyBallonPopperData = newData;
      //simulateUnityTraining(value);
      loadUnityScene("hec_training");
    } else if (value === TestType.veggie_samurai) {
      const newData = generateVeggieSamuraiData();
      dummyVeggieSamuraiData = newData;
      //simulateUnityTraining(value);
      loadUnityScene("veggie_samurai");
    }
  };

  const handleTugClick = (value: any, isDummy: boolean) => {
    if (isDummy) {
      // Handle dummy data for TUG
      const newData = generateRandomTugData();
      dummyTugData = newData;
      simulateUnityTraining(value);
    } else {
      handleClick(value);
    }
  };
  const handleFRClick = (value: any, isDummy: boolean) => {
    if (isDummy) {
      // Handle dummy data for FR
      const newData = generateRandomFunctionalReachData();
      dummyFunctionalReachData = newData;
      simulateUnityTraining(value);
    } else {
      handleClick(value);
    }
  };
  const handleMctsibClick = (value: any, isDummy: boolean) => {
    if (isDummy) {
      // Generate random data which returns an array of 4 phases
      const newData = generateRandomMctsibData();
      dummyMctsibData = newData;
      simulateUnityTraining(value);
    } else {
      handleClick(value);
    }
  };
  // This receives the message from the unity application (currently will only be json data unless other messages are needed)
  (window as any).receiveUnityMessage = function (message: string): void {
    let data = JSON.parse(message).activity;
    console.log("Message received from Unity:", data);
    if (data.test_type === "game_RLGL") {
      dummyRLGLData = data;
      simulateUnityTraining(TestType.red_light_green_light);
    } else if (data.test_type === "game_AF") {
      dummyAppleFrenzyData = data;
      simulateUnityTraining(TestType.game_AF);
    } else if (data.test_type === "hec_training") {
      dummyBallonPopperData = data;
      simulateUnityTraining(TestType.hec_training);
    } else if (data.test_type === "veggie_samurai") {
      dummyVeggieSamuraiData = data;
      simulateUnityTraining(TestType.veggie_samurai);
    }
  };

  const redirectToPatientPage = () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    localStorage.setItem("isAfterCreatePatientCall", "true");
    history.push("/patient-page");
  };

  return (
    <IonPage placeholder={undefined}>
      <IonModal
        className="assessment-description-modal-wrap"
        backdropDismiss={false}
        isOpen={assessmentDescModal}
        placeholder={undefined}
      >
        <AssessmentDescription
          setShowModal1={setShowModal1}
        ></AssessmentDescription>
      </IonModal>
      <IonHeader
        className="ion-no-border select-an-assessment-page-header"
        placeholder={undefined}
      >
        <TopLeftUserName headerText="Patient Assessment Page"></TopLeftUserName>
        <div
          className="cross-icon"
          onClick={() => {
            redirectToPatientPage();
          }}
        >
          <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5 31C24.5081 31 31 24.5081 31 16.5C31 8.49187 24.5081 2 16.5 2C8.49187 2 2 8.49187 2 16.5C2 24.5081 8.49187 31 16.5 31Z"
              fill="white"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3332 21.3332L11.6667 11.6666"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3333 11.6666L11.6667 21.3333"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </IonHeader>
      <IonContent placeholder={undefined} className="slide-in-right">
        {!isLoading ? (
          <div>
            <div className="main-heading">
              <h1>Select an Assessment</h1>
            </div>
            <div className="container">
              <div className="assesment-page-tab-btn">
                <button
                  className={`assesment-btn ${
                    activeTab === "assessment" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("assessment")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="28"
                    viewBox="0 0 29 28"
                    fill="none"
                  >
                    <path
                      d="M22.9996 11.3733C22.9996 13.8831 22.1849 16.2015 20.8124 18.0825L27.7348 25.0104C28.4183 25.6939 28.4183 26.8039 27.7348 27.4874C27.0513 28.1709 25.9414 28.1709 25.2579 27.4874L18.3354 20.5595C16.4545 21.9374 14.1361 22.7467 11.6263 22.7467C5.34359 22.7467 0.25293 17.656 0.25293 11.3733C0.25293 5.09066 5.34359 0 11.6263 0C17.9089 0 22.9996 5.09066 22.9996 11.3733ZM5.9396 11.8108V15.3103C5.9396 16.0375 6.52467 16.6226 7.2519 16.6226C7.97914 16.6226 8.56421 16.0375 8.56421 15.3103V11.8108C8.56421 11.0835 7.97914 10.4985 7.2519 10.4985C6.52467 10.4985 5.9396 11.0835 5.9396 11.8108ZM10.314 6.56154V15.3103C10.314 16.0375 10.899 16.6226 11.6263 16.6226C12.3535 16.6226 12.9386 16.0375 12.9386 15.3103V6.56154C12.9386 5.8343 12.3535 5.24923 11.6263 5.24923C10.899 5.24923 10.314 5.8343 10.314 6.56154ZM14.6883 10.061V15.3103C14.6883 16.0375 15.2734 16.6226 16.0006 16.6226C16.7279 16.6226 17.3129 16.0375 17.3129 15.3103V10.061C17.3129 9.33379 16.7279 8.74872 16.0006 8.74872C15.2734 8.74872 14.6883 9.33379 14.6883 10.061Z"
                      fill="#005A75"
                    />
                  </svg>
                  Assessment
                </button>
                <button
                  className={`assesment-btn ${
                    activeTab === "training" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("training")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="41"
                    height="28"
                    viewBox="0 0 41 28"
                    fill="none"
                  >
                    <path
                      d="M8.75 3.5C8.75 1.56875 10.3188 0 12.25 0H13.25C15.1812 0 16.75 1.56875 16.75 3.5V12.5H24.75V3.5C24.75 1.56875 26.3188 0 28.25 0H29.25C31.1812 0 32.75 1.56875 32.75 3.5V4.5H34.25C36.1813 4.5 37.75 6.06875 37.75 8V12.5H39.25C40.0812 12.5 40.75 13.1687 40.75 14C40.75 14.8313 40.0812 15.5 39.25 15.5H37.75V20C37.75 21.9312 36.1813 23.5 34.25 23.5H32.75V24.5C32.75 26.4312 31.1812 28 29.25 28H28.25C26.3188 28 24.75 26.4312 24.75 24.5V15.5H16.75V24.5C16.75 26.4312 15.1812 28 13.25 28H12.25C10.3188 28 8.75 26.4312 8.75 24.5V23.5H7.25C5.31875 23.5 3.75 21.9312 3.75 20V15.5H2.25C1.41875 15.5 0.75 14.8313 0.75 14C0.75 13.1687 1.41875 12.5 2.25 12.5H3.75V8C3.75 6.06875 5.31875 4.5 7.25 4.5H8.75V3.5ZM11.75 4.5V6V22V23.5V24.5C11.75 24.775 11.975 25 12.25 25H13.25C13.525 25 13.75 24.775 13.75 24.5V3.5C13.75 3.225 13.525 3 13.25 3H12.25C11.975 3 11.75 3.225 11.75 3.5V4.5ZM8.75 7.5H7.25C6.975 7.5 6.75 7.725 6.75 8V20C6.75 20.275 6.975 20.5 7.25 20.5H8.75V7.5ZM29.75 22V6V4.5V3.5C29.75 3.225 29.525 3 29.25 3H28.25C27.975 3 27.75 3.225 27.75 3.5V24.5C27.75 24.775 27.975 25 28.25 25H29.25C29.525 25 29.75 24.775 29.75 24.5V23.5V22ZM34.25 20.5C34.525 20.5 34.75 20.275 34.75 20V8C34.75 7.725 34.525 7.5 34.25 7.5H32.75V20.5H34.25Z"
                      fill="#005A75"
                    />
                  </svg>
                  Training
                </button>
              </div>
            </div>
            <IonGrid
              className="container select-an-assessment-page"
              placeholder={undefined}
            >
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  {activeTab === "assessment" && (
                    <div className="assement-tab">
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleClick(TestType.gait);
                          }}
                        >
                          <img src={gaitAssesment} alt="gaitAssesment" />
                          <div className="select-an-assesment-caption">
                            <span>Gait</span>
                          </div>
                        </div>
                      </div>
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleClick(TestType.five_x_sit_stand);
                          }}
                        >
                          <img src={fivesitStand} alt="fivesitStand" />
                          <div className="select-an-assesment-caption">
                            <span>5x Sit To Stand</span>
                          </div>
                        </div>
                      </div>
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleClick(TestType.upper_body_arom);
                          }}
                        >
                          <img
                            src={upperBodyAromAssessment}
                            alt="upperBodyAromAssessment"
                          />
                          <div className="select-an-assesment-caption">
                            <span>Upper Body AROM</span>
                          </div>
                        </div>
                      </div>
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleMctsibClick(TestType.ctsib, false);
                          }}
                        >
                          <img src={mCTSIB} alt="mCTSIB" />
                          <div className="select-an-assesment-caption">
                            <span>mCTSIB</span>
                          </div>
                        </div>
                      </div>
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleTugClick(TestType.tug, false);
                          }}
                        >
                          <img src={tugAssessment} alt="tugAssessment" />
                          <div className="select-an-assesment-caption">
                            <span>TUG</span>
                          </div>
                        </div>
                      </div>
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleFRClick(TestType.reach, false);
                          }}
                        >
                          <img
                            src={functionalReachAssessment}
                            alt="functionalReachAssessment"
                          />
                          <div className="select-an-assesment-caption">
                            <span>Functional Reach</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === "training" && (
                    <div className="training-tab ">
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleTrainingClick(TestType.red_light_green_light);
                          }}
                        >
                          <img
                            src={redLightGreenLight}
                            alt="redLightGreenLightTraining"
                          />
                          <div className="select-an-assesment-caption">
                            <span>Red Light Green Light</span>
                          </div>
                        </div>
                      </div>
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleTrainingClick(TestType.hec_training);
                          }}
                        >
                          <img src={ballonPopper} alt="ballonPopperTraining" />
                          <div className="select-an-assesment-caption">
                            <span>Balloon Popper</span>
                          </div>
                        </div>
                      </div>
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleTrainingClick(TestType.game_AF);
                          }}
                        >
                          <img src={appleFrenzy} alt="apple-frenzy" />
                          <div className="select-an-assesment-caption">
                            <span>Apple Frenzy</span>
                          </div>
                        </div>
                      </div>
                      <div className="select-assessment-inner-sec">
                        <div
                          className="select-assessment-img-wrap"
                          onClick={() => {
                            handleTrainingClick(TestType.veggie_samurai);
                          }}
                        >
                          <img src={veggieSlicer} alt="ballonPopperTraining" />
                          <div className="select-an-assesment-caption">
                            <span>Veggie Slicer</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
        ) : (
          <Loader />
        )}
      </IonContent>
    </IonPage>
  );
};
export default SelectAnAssessment;
